import { render, staticRenderFns } from "./VendaPedidoGet.vue?vue&type=template&id=6fa80dd6&scoped=true"
import script from "./VendaPedidoGet.vue?vue&type=script&lang=js"
export * from "./VendaPedidoGet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa80dd6",
  null
  
)

export default component.exports